import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import { VIEWER_FIELDS } from './queries'
import type { Application } from './types'

export const CREATE_APPLICATION: TypedDocumentNode<
  { createApplication: Application },
  {
    client_id: string
    name: string
    onesignal_id?: string | null
    onesignal_rest_api_key?: string | null
    livestream_preset?: string | null
    accesses?: string[]
    observations?: string | null
    min_version?: string | null
    latest_version?: string | null
    store_url_android?: string | null
    store_url_ios?: string | null
    api_base_url?: string | null
    image_base_url?: string | null
  }
> = gql`
  mutation CreateApplication($client_id: ID!, $name: String!, $onesignal_id: String, $onesignal_rest_api_key: String, $livestream_preset: String, $accesses: [String!], $observations: String, $min_version: String, $latest_version: String, $store_url_android: String, $store_url_ios: String, $api_base_url: String, $image_base_url: String) {
    createApplication(client_id: $client_id, name: $name, onesignal_id: $onesignal_id, onesignal_rest_api_key: $onesignal_rest_api_key, livestream_preset: $livestream_preset, accesses: $accesses, observations: $observations, min_version: $min_version, latest_version: $latest_version, store_url_android: $store_url_android, store_url_ios: $store_url_ios, api_base_url: $api_base_url, image_base_url: $image_base_url) {
      id client_id name onesignal_id onesignal_rest_api_key livestream_preset accesses observations min_version latest_version store_url_android store_url_ios api_base_url image_base_url created_at updated_at
      ${VIEWER_FIELDS}
    }
  }
`

export const UPDATE_APPLICATION: TypedDocumentNode<
  { updateApplication: Application },
  {
    id: string
    name?: string
    onesignal_id?: string | null
    onesignal_rest_api_key?: string | null
    livestream_preset?: string | null
    accesses?: string[]
    observations?: string | null
    min_version?: string | null
    latest_version?: string | null
    store_url_android?: string | null
    store_url_ios?: string | null
    api_base_url?: string | null
    image_base_url?: string | null
  }
> = gql`
  mutation UpdateApplication($id: ID!, $name: String, $onesignal_id: String, $onesignal_rest_api_key: String, $livestream_preset: String, $accesses: [String!], $observations: String, $min_version: String, $latest_version: String, $store_url_android: String, $store_url_ios: String, $api_base_url: String, $image_base_url: String) {
    updateApplication(id: $id, name: $name, onesignal_id: $onesignal_id, onesignal_rest_api_key: $onesignal_rest_api_key, livestream_preset: $livestream_preset, accesses: $accesses, observations: $observations, min_version: $min_version, latest_version: $latest_version, store_url_android: $store_url_android, store_url_ios: $store_url_ios, api_base_url: $api_base_url, image_base_url: $image_base_url) {
      id client_id name onesignal_id onesignal_rest_api_key livestream_preset accesses observations min_version latest_version store_url_android store_url_ios api_base_url image_base_url created_at updated_at
      ${VIEWER_FIELDS}
    }
  }
`

export const DELETE_APPLICATION: TypedDocumentNode<{ deleteApplication: boolean }, { id: string }> =
  gql`
  mutation DeleteApplication($id: ID!) {
    deleteApplication(id: $id)
  }
`
